import React, {memo, useEffect, useState} from "react";
import {TextField, CircularProgress} from "@material-ui/core";
import {Autocomplete} from "@material-ui/lab";
import {useRequest} from "../../../../../hooks/request.hook";
import "./index.scss";


//value должно быть id или массив id, если multiple
//options должны быть массивом из {name: '', value: id}

const AsyncSelect = ({className, label, url, multiple = false, disableClearable = false, value = [], onChange, ...props}) => {
    const [options, setOptions] = useState([]);
    const {loading, request} = useRequest();

    useEffect(() => {
        if (url) {
            request({url}).then(data => {
                if (data) setOptions(data);
            });
        }
    }, [url, request]);

    return (
        <Autocomplete
            className={`async-select${className ? ' ' + className : ''}`}
            multiple={multiple}
            disableClearable={disableClearable}
            loadingText="Загрузка..."
            noOptionsText="Ничего не найдено"
            loading={loading}
            options={options}
            value={multiple ?
                options.length ?
                    value.map(id => options.find(opt => opt.value === id)) :
                    [] :
                options.filter(opt => opt.value === value)[0] || ''
            }
            getOptionSelected={(option, value) => option.name === value.name}
            getOptionLabel={option => option.name || ''}
            onChange={(e, newValue) => onChange(
                multiple ? newValue.map(item => item.value) : newValue ? newValue.value : ''
            )}
            renderInput={params => (
                <TextField
                    {...params}
                    label={label}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading && <CircularProgress color="inherit" size={20} />}
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                />
            )}
            {...props}
        />
    )
};

export default memo(AsyncSelect);